import { useSearchParams } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import PageHero from '../components/PageHero';
import ContactForm from '../components/ContactForm';
import { Reveal, FadeIn } from '../components/Reveal';
import { IMAGES } from '../lib/site';

const OFFICES = [
    ['New York', 'Global Headquarters', '245 Park Avenue, New York, NY'],
    ['Washington, DC', 'Policy & Partnerships', '1200 Pennsylvania Ave NW'],
    ['London', 'EMEA Operations', 'One St James Square'],
    ['Singapore', 'APAC Operations', 'Ocean Financial Centre'],
];

export default function Contact() {
    const [params] = useSearchParams();
    const interest = params.get('interest') || '';

    return (
        <>
            <PageHero
                overline="Strategic Consultation"
                lines={['Begin the', 'conversation.']}
                sub="Share your market adoption or corporate development objectives. A senior advisor — never a bot — responds within one business day."
            />

            <section className="py-20 sm:py-28 border-t border-line">
                <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14">
                    <div className="lg:col-span-7">
                        <Reveal>
                            <h2 className="font-serif text-2xl sm:text-3xl text-cream mb-10">
                                Request a <span className="text-bronze">consultation.</span>
                            </h2>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <ContactForm defaultInterest={interest} />
                        </Reveal>
                    </div>

                    <div className="lg:col-span-5">
                        <FadeIn delay={0.15}>
                            <div className="relative mb-10">
                                <div className="absolute -inset-3 border border-bronze/25 translate-x-4 translate-y-4 pointer-events-none" />
                                <img
                                    src={IMAGES.skyscraper}
                                    alt="Corporate skyline at twilight"
                                    className="relative w-full aspect-[16/10] object-cover grayscale-[35%] contrast-110"
                                />
                            </div>
                        </FadeIn>
                        <Reveal delay={0.2}>
                            <div className="dark-section space-y-5 border border-line p-8">
                                <p className="flex items-center gap-3 text-sm text-fog">
                                    <Mail size={15} className="text-bronze shrink-0" />
                                    counsel@commpro.com
                                </p>
                                <p className="flex items-center gap-3 text-sm text-fog">
                                    <Phone size={15} className="text-bronze shrink-0" />
                                    +1 (212) 555-0184
                                </p>
                                <div className="pt-5 border-t border-line space-y-4">
                                    {OFFICES.map(([city, label, addr]) => (
                                        <div key={city} data-testid={`office-${city.toLowerCase().replace(/[^a-z]+/g, '-')}`} className="flex items-start gap-3">
                                            <MapPin size={15} className="text-bronze shrink-0 mt-0.5" />
                                            <div>
                                                <p className="text-sm text-cream">
                                                    {city} <span className="text-fog">— {label}</span>
                                                </p>
                                                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-fog mt-1">
                                                    {addr}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>
        </>
    );
}
